import { FC } from 'react';
import { TopToolbar } from 'react-admin';
import { Box } from '@mui/material';
import { ShsTitle, ShsToggle, WithRole } from 'src/components/common';
import { UserRole } from 'src/auth/types';
import { ScheduleEducationCenters } from './ScheduleEducationCenters';
import { AdminNoSecretariatGroup, HospitalAvailableRoles } from 'src/constants/roles';
import { ScheduleEducationCentersTeacher } from './ScheduleEducationCenterTeacher';

export const ScheduleToolbar: FC = () => {
    return (
        <TopToolbar
            sx={{
                width: '100%',
                display: 'flex',
                gap: '16px',
                alignItems: 'center',
                marginTop: '20px',
                marginBottom: '12px',
                '.ShsTitle-root': { marginBottom: 0 }
            }}>
            <Box display={'flex'} flexDirection={'column'} width={'100%'} gap={'16px'}>
                <Box sx={{ flex: 1, display: 'flex', gap: '16px', flexDirection: 'row', alignItems: 'flex-end' }}>
                    <ShsTitle title="Розклад" />
                    <WithRole roles={AdminNoSecretariatGroup}>
                        <ShsToggle
                            label="Режим перегляду"
                            source="viewMode"
                            sx={{
                                '.MuiFormHelperText-root': {
                                    display: 'none'
                                },
                                '& .MuiSwitch-root': {
                                    height: '1.3rem',
                                    width: '40px',
                                    '& .MuiSwitch-switchBase': {
                                        padding: '4px 4px',
                                        '& .toggle-button': {
                                            width: '13px',
                                            height: '13px'
                                        }
                                    }
                                }
                            }}
                        />
                    </WithRole>
                </Box>

                <Box
                    display={'flex'}
                    flexDirection={'row'}
                    gap={'16px'}
                    alignItems={'center'}
                    justifyContent={'space-between'}>
                    <WithRole roles={[UserRole.SYSTEM_ADMIN, UserRole.SECRETARIAT]}>
                        <ScheduleEducationCenters />
                    </WithRole>
                    <WithRole roles={HospitalAvailableRoles}>
                        <ScheduleEducationCentersTeacher />
                    </WithRole>
                </Box>
            </Box>
        </TopToolbar>
    );
};
